import { render, staticRenderFns } from "./CampaignListShow.vue?vue&type=template&id=48a5508d&"
import script from "./CampaignListShow.vue?vue&type=script&lang=js&"
export * from "./CampaignListShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports